//应用配置
module.exports = {
    appTitle:"页面",
    apiPath: "/routeryun",
  };
  